import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ maxHeightTable }: Theme) => ({
  tableContainer: {
    margin: '0 20px',
    width: 'calc(100% - 40px)',
    maxHeight: maxHeightTable,
  },
  bold: {
    fontWeight: 'bold',
  },
  buttonsTableCell: {
    padding: 5,
    width: 100,
    minWidth: 100,
  },
  colorCell: {
    width: 30,
    minWidth: 30,
  },
  wrap: {
    maxWidth: 400,
    wordWrap: 'break-word',
  },
}));
